import { cva } from 'class-variance-authority';
import type { SmallIconButtonSizes } from './types';

export const smallIconButtonVariants = cva(
  'focus-visible:ring-gray justify-center items-center flex p-0',
  {
    variants: {
      size: {
        xs: 'size-3 rounded-xs',
        sm: 'size-4 rounded-xs',
        md: 'size-5 rounded-xs',
        lg: 'size-6 rounded-sm',
        xl: 'size-7 rounded-sm',
        xxl: 'size-8 rounded-sm',
      } satisfies Record<SmallIconButtonSizes, string>,
      variant: {
        solid: '',
        outline: 'border border-secondary',
      },
    },
  },
);

export const smallIconButtonIconVariants = cva('shrink-0', {
  variants: {
    size: {
      xs: 'size-2',
      sm: 'size-3',
      md: 'size-4',
      lg: 'size-5',
      xl: 'size-5',
      xxl: 'size-6',
    } satisfies Record<SmallIconButtonSizes, string>,
  },
});
